<div class="container">
  <!-- Component Key Onboarding Form-->
  <form
    [hidden]="loading"
    [formGroup]="updateTransitTimeForm"
    (ngSubmit)="submit()"
    class="pure-form pure-form-stacked"
  >
    <!-- Select option for From Country Code Options -->
    <div class="pure-control-group">
      <label for="fromCountryCodeId"
        >From Country Code
        <app-popover [message]="help_messages.from_country_code"></app-popover
      ></label>
      <select
        id="fromCountryCodeId"
        class="pure-input-2-3"
        formControlName="fromCountryCode"
        #fromCountryCode
        (change)="onFromCountryCodeChange(fromCountryCode.value)"
      >
        <option
          *ngFor="let _fromCountryCode of fromCountryCodeOptions; let i = index"
          [value]="_fromCountryCode"
        >
          {{ _fromCountryCode }}
        </option>
      </select>
    </div>

    <div class="pure-control-group">
      <label for="businessUseCase"
        >Business Use Case
        <app-popover [message]="help_messages.business_unit"></app-popover
      ></label>
      <select
        name="businessUseCase"
        id="businessUseCase"
        class="pure-input-2-3"
        formControlName="businessUseCase"
        #businessUseCaseRef
        (change)="onBusinessUseCaseChange(businessUseCaseRef.value)"
      >
        <ng-template ngFor let-item [ngForOf]="getItems">
          <optgroup label="{{ item.name }}">
            <option
              *ngFor="let usecase of item.usecases"
              [value]="usecase.value"
            >
              {{ usecase.text }}
            </option>
          </optgroup>
        </ng-template>
      </select>
    </div>

    <!-- Read only text for displaying onboarded component key placeholder-->
    <label for="componentKeyPlaceholderId"
      >Level Of Data
      <app-popover [message]="help_messages.level_of_data"></app-popover
    ></label>
    <input
      id="componentKeyPlaceholderId"
      class="pure-input-2-3"
      type="text"
      formControlName="componentKeyPlaceholder"
      readonly
    />

    <!-- Dynamic entries for Component Key Place holder parts -->
    <form [formGroup]="updateTransitTimeForm.get('componentKeyValue')">
      <div *ngFor="let field of currentComponentKeyPlaceholder; let i = index">
        <label for="{{ 'componentKeyValue' + i }}">{{ field }}</label>
        <select
          type="text"
          [formControlName]="field"
          class="pure-input-2-3"
          id="{{ 'componentKeyValue' + i }}"
        >
          <option
            *ngFor="let option of dropDownOptions[field]"
            [value]="option"
            [disabled]="passportEnabledShipmethods[option]"
          >
            {{ option }}
          </option>
        </select>
      </div>
    </form>

    <div [hidden]="singleTransitTimeColumns.length == 0">
      <label for="schema"
        >Required Schema Format of the Transit Time Files for the selected
        Business use case
        <app-popover [message]="help_messages.expected_schema"></app-popover>
      </label>
      <div id="schema" class="p-3 mb-2 text-dark">
        <app-table
          [label]="single"
          [header]="singleTransitTimeColumns"
        ></app-table>
        <app-table
          [label]="range"
          [header]="rangeTransitTimeColumns"
        ></app-table>
      </div>
    </div>

    <label for="transitTimeTypeId"
      >Select Transit Time Type
      <app-popover [message]="help_messages.transit_time_type"></app-popover
    ></label>
    <select
      formControlName="transitTimeType"
      id="transitTimeTypeId"
      class="pure-input-2-3"
      #transitTimeTypeRef
      (change)="onTransitTimeTypeChange(transitTimeTypeRef.value)"
    >
      <option
        *ngFor="let _transitTime of transitTimeOptions; let i = index"
        [value]="_transitTime"
      >
        {{ _transitTime }}
      </option>
    </select>

    <label for="uploadTypeId"
      >Transit Time Upload Type
      <app-popover
        [message]="help_messages.transit_time_upload_type"
      ></app-popover
    ></label>
    <select
      formControlName="uploadType"
      id="uploadTypeId"
      class="pure-input-2-3"
      #transitTimeUploadTypeRef
      (change)="onTransitTimeUploadFileTypeChange()"
    >
      >
      <option
        *ngFor="let uploadTypeOption of uploadTypeOptions; let i = index"
        [value]="uploadTypeOption"
      >
        {{ uploadTypeOption }}
      </option>
    </select>

    <label for="removeTransitTimeLanesFileTypeId"
      >Remove Transit Time Lanes File Type
      <app-popover
        [message]="help_messages.remove_transit_time_lanes_file_type"
      ></app-popover
    ></label>
    <select
      formControlName="removeTransitTimeLanesFileType"
      id="removeTransitTimeLanesFileTypeId"
      class="pure-input-2-3"
      #removeTransitTimeLanesFileTypeRef
    >
      >
      <option
        *ngFor="
          let removeTransitTimeLanesFileTypeOption of removeTransitTimeLanesFileTypeOptions;
          let i = index
        "
        [value]="removeTransitTimeLanesFileTypeOption"
      >
        {{ removeTransitTimeLanesFileTypeOption }}
      </option>
    </select>

    <div *ngIf="getTransitTimeUploadTypeValue === 'UI_UPLOAD'">
      <label for="fileUpload"
        >Upload File <app-popover [message]="help_messages.file"></app-popover
      ></label>
      <input
        type="file"
        formControlName="transitTimeFile"
        (change)="onFileChange($event)"
        class="pure-input-2-3"
        id="fileUpload"
        accept=".tsv"
      />
    </div>

    <div *ngIf="getTransitTimeUploadTypeValue === 'S3_UPLOAD'">
      <label for="s3FilePath"
        >S3 File Path
        <app-popover [message]="help_messages.s3_file_path"></app-popover>
      </label>
      <select
        formControlName="s3FilePath"
        id="s3FilePath"
        class="pure-input-2-3"
      >
        <option
          *ngFor="let s3FilePath of s3FilePathOptions; let i = index"
          [value]="s3FilePath"
        >
          {{ s3FilePath }}
        </option>
      </select>
    </div>

    <!-- Submit button-->
    <div>
      <button
        class="pure-button pure-button-primary button-large"
        type="submit"
        [disabled]="
          updateTransitTimeForm.invalid || (progress > 0 && progress < 100)
        "
      >
        Submit
      </button>
    </div>
  </form>
  <div class="progress" *ngIf="progress > 0">
    <div
      class="progress-bar progress-bar-animated progress-bar-striped bg-success"
      role="progressbar"
      [style.width.%]="progress"
    >
      {{ progress }}%
    </div>
  </div>
  <app-loader [loading]="loading" [size]="'small'"></app-loader>
</div>
